import * as React from 'react';
import { Alert } from 'reactstrap';
import styled from 'styled-components';

import { Toast } from '../framework/ToasterState';

export interface ToasterProps {
  toasts: Toast[];
}

// We need the alert to appear above anything else in the DOM.
// Bootstrap's highest z-index is 1070, so we're using 2000 ensure we're above all other elements.
const AlertWrapper = styled.div`
  &&& {
    z-index: 2000;
  }
`;


export class Toaster extends React.Component<ToasterProps> {
  render() {
    return (
      <AlertWrapper className="fixed-bottom w-100" style={{ left: 'auto', maxWidth: '450px' }}>
        {this.props.toasts.map((toast) => (
          <Alert className="shadow p-0 mx-2 d-flex align-items-stretch" color={toast.color} key={toast.id}>
            {Boolean(toast.iconHint) &&
              <span className="d-flex align-items-center pl-3 m-0">
                <i className="material-icons">{toast.iconHint}</i>
              </span>
            }
            <span className="flex-fill flex-grow p-3">{toast.message}</span>
            <span className="d-flex align-items-center pr-3">
              <i className="material-icons" style={{ cursor: 'pointer' }} onClick={() => toast.dismiss()}>close</i>
            </span>
          </Alert>
        ))}
      </AlertWrapper>
    );
  }
}



// WEBPACK FOOTER //
// ./src/portal-react-app/Toaster.tsx